import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import LensIcon from '@material-ui/icons/Lens';
import PauseIcon from '@material-ui/icons/Pause';
import PlayIcon from '@material-ui/icons/PlayArrow';
import { styles } from '../../styles/slideshow-styles';

function SlideIndicator(props) {
  const { classes } = props;

  const slideIndicator = () => {
    return props.slides.map((slide, index) => {
      if(index === props.currentIndex) {
        return (
          <IconButton onClick={e => {props.handleGoToSlide(index)}} disabled key={index}>
            <LensIcon color="secondary" fontSize="small" />
          </IconButton>
        )
      } else {
        return (
          <IconButton onClick={e => {props.handleGoToSlide(index)}} key={index}>
            <LensIcon color="disabled" fontSize="small" />
          </IconButton>
        )
      }
    })
  }

  return (

    <div>
      {slideIndicator()}
    </div>
  )
}

SlideIndicator.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SlideIndicator);



// WEBPACK FOOTER //
// ./src/components/slideshow/SlideIndicator.js